import { parameterOptionSchema } from "@/lib/schema/configuration/parameter"
import { z } from "zod"

export const generalSettingsSchema = z.object({
    name: z.string(),
    crm_system: z.string().nullable().optional(),
    description: z.string(),
    parameters: z.array(z.object({
        parameter_id: z.string().optional().nullable(),
        value: z.string().optional().nullable(),
        name: z.string().optional().nullable(),
        options: z.array(parameterOptionSchema)
    })).optional().nullable(),
    default_parameters: z.array(z.object({
        parameter_id: z.string().optional().nullable(),
        value: z.string().optional().nullable(),
        name: z.string().optional().nullable(),
    })).optional().nullable(),
})